import { createAppSlice } from "../../app/createAppSlice";
import type { AppThunk } from "../../app/store";
import { ng } from "@common/ngds";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
export const getConfig = createAction<number>("api/users");

export type configState = {
  config: any | null;
  status: "idle" | "loading" | "failed";
};

export const fetchConfig = createAsyncThunk(
  "config/config",
  async () => {
    const resp = await fetch(`/api/config/`);
    let a = await resp.json();
    return a;
  },
  {
    condition: (_arg, { getState }) => {
      const state = getState() as { configSlice?: { status?: configState["status"] } };
      return state.configSlice?.status !== "loading";
    },
  },
);

export function useConfig() {
  const dispatch = useAppDispatch();

  const fetchConfigData = () => {
    dispatch(fetchConfig());
  };

  return [fetchConfigData] as const;
}

const initialState: configState = {
  config: null,
  status: "idle",
};

export const ConfigSlice = createAppSlice({
  name: "configSlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchConfig.pending, (state) => {
      console.log(" config pending");
      state.status = "loading";
    });
    builder.addCase(fetchConfig.fulfilled, (state, action) => {
      console.log(" config fulfilled", action.payload);
      state.status = "idle";
      state.config = action.payload;
    });
    builder.addCase(fetchConfig.rejected, (state) => {
      state.status = "failed";
    });
  },
  selectors: {
    selectConfig: (state) => state.config,
  },
});

export const { selectConfig } = ConfigSlice.selectors;
